function isWatchiFacesGallery(): boolean {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname.toLowerCase();
  return (
    hostname === 'watchi-faces-gallery.app' ||
    hostname.endsWith('.watchi-faces-gallery.app') ||
    hostname === '46.62.129.76'
  );
}

function preserveCase(source: string, replacement: string): string {
  return replacement
    .split('')
    .map((letter, index) =>
      source[index] === source[index].toUpperCase()
        ? letter.toUpperCase()
        : letter.toLowerCase()
    )
    .join('');
}

export function funnelText(text: string): string {
  if (isWatchiFacesGallery()) return text;

  return text.replace(/\bsmart\b/gi, (word) => preserveCase(word, 'apple'));
}
